export default "__VITE_ASSET__Sw9ArLOS__"